import Image from 'next/image';
import logoImage from '../../assets/images/aidoo_logo_beta.png';
import styled from 'styled-components';
import { useRouter } from 'next/navigation';

const Header = () => {
  const router = useRouter()
  return (
    <HeaderContainer>
      <LogoWrapper onClick={() => router.push('/')}>
        <Image src={logoImage} alt="로고이미지" width={290} height={58} priority />
      </LogoWrapper>
      <NavWrapper>
        <NavItem>회사소개</NavItem>
        <NavItem onClick={() => router.push('/question')}>AI 교육진단</NavItem>
        <NavItem>교육이력 관리</NavItem>
        <NavItem>문의하기</NavItem>
        <NavItem>교육기관 찾기</NavItem>
      </NavWrapper>
    </HeaderContainer>
  );
};

export default Header;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LogoWrapper = styled.div`
  cursor: pointer
`;

const NavWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.25rem;
  font-size: 14px;
  color: #868e96;
`;

const NavItem = styled.div`
  cursor: pointer;
  &:hover {
    color: #1e90ff;
  }
`;
